import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getAll,
  getId,
  createItem,
  updateItem,
  deleteById,
  getInvoice,
  synchProduct,
} from "./orderAPI";

const initialState = {
  data: [],
  dataId: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
};

export const fetchData = createAsyncThunk(
  "order/fetchData",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  },
);
export const fetchInvoice = createAsyncThunk(
  "order/fetchInvoice",
  async (payload) => {
    const response = await getInvoice(payload);
    return response;
  },
);
export const fetchOrder = createAsyncThunk(
  "order/fetchOrder",
  async (payload) => {
    const response = await getAll(payload);
    return response;
  },
);

export const fetchId = createAsyncThunk("order/fetchId", async (id) => {
  const response = await getId(id);
  return response;
});
export const fetchIdNoloading = createAsyncThunk(
  "order/fetchIdNoloading",
  async (id) => {
    const response = await getId(id);
    return response;
  },
);

export const addItem = createAsyncThunk("order/addItem", async (payload) => {
  const response = await createItem(payload);
  return response;
});

export const getSychAll = createAsyncThunk(
  "order/getProdut",
  async (payload) => {
    const response = await synchProduct(payload);
    return response;
  },
);

export const editItem = createAsyncThunk("order/editItem", async (payload) => {
  const response = await updateItem(payload);
  return response;
});
export const removeById = createAsyncThunk(
  "order/removeById",
  async (payload) => {
    const response = await deleteById(payload);
    return response;
  },
);

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchOrder.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecords;
      })
      .addCase(fetchId.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchId.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(fetchIdNoloading.pending, (state) => {
        state.loading = false;
      })
      .addCase(fetchIdNoloading.fulfilled, (state, action) => {
        state.loading = false;
        state.dataId = action.payload.data.data;
      })
      .addCase(addItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(addItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editItem.pending, (state) => {
        state.loading = true;
      })
      .addCase(editItem.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeById.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeById.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchInvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(getSychAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSychAll.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = orderSlice.actions;

export const selectData = (state) => state.order.data;
export const selectOrder = (state) => state.order.data;
export const selectId = (state) => state.order.dataId;
export const selectLoading = (state) => state.order.loading;
export const selectLoadingOrder = (state) => state.order.loading;
export const selectError = (state) => state.order.error;
export const selectPageNo = (state) => state.order.pageNo;
export const selectPageSize = (state) => state.order.pageSize;
export const selectTotalRecord = (state) => state.order.totalRecord;
export const selectSelected = (state) => state.order.selected;
export const selectResult = (state) => state.order.result;

export default orderSlice.reducer;
